"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ID = void 0;
var react_1 = __importDefault(require("react"));
var DecorativeShape_1 = __importDefault(require("../DecorativeShape"));
var Grid_1 = __importDefault(require("../Grid"));
var Link_1 = __importDefault(require("../../navigation/Link"));
var Markdown_1 = __importDefault(require("../../utils/Markdown"));
var typography_1 = require("../../typography");
var TextVerticalSpacer_1 = __importDefault(require("../../utils/TextVerticalSpacer"));
var HorizontalSpacer_1 = __importDefault(require("../../utils/HorizontalSpacer"));
exports.ID = 'OVERVIEW';
var GRID_1_ROW_GAP = { small: 24 };
var MARKDOWN_1_OVERRIDES = {
    div: function (_a) {
        var children = _a.children;
        return react_1.default.createElement(TextVerticalSpacer_1.default, { level: "4" }, children);
    },
    p: function (_a) {
        var children = _a.children;
        return react_1.default.createElement(typography_1.Body, { level: "2" }, children);
    },
    a: function (_a) {
        var href = _a.href, children = _a.children;
        return (react_1.default.createElement(Link_1.default, { href: href, isExternal: true }, children));
    },
};
var SPAN = {
    2: {
        first: {
            small: 'full',
            medium: 4,
            large: 5,
        },
        second: {
            small: 'full',
            medium: 4,
            large: [2, 6],
        },
    },
    3: {
        first: {
            small: 'full',
            medium: 4,
            large: 4,
        },
        second: {
            small: 'full',
            medium: 4,
            large: 4,
        },
    },
};
var HighlightList = function (_a) {
    var _b = _a.columns, columns = _b === void 0 ? 2 : _b, _c = _a.children, children = _c === void 0 ? [] : _c, commonProps = __rest(_a, ["columns", "children"]);
    return (react_1.default.createElement(Grid_1.default, __assign({ "data-component-name": "HighlightList" }, commonProps, { rowGap: GRID_1_ROW_GAP }), children.map(function (item, i) { return (react_1.default.createElement(Grid_1.default.Cell, { "data-component-name": "HighlightListItem", key: i, span: i % 2 ? SPAN[columns].first : SPAN[columns].second },
        react_1.default.createElement(HorizontalSpacer_1.default, { align: "top" },
            react_1.default.createElement("div", null,
                react_1.default.createElement(DecorativeShape_1.default, { name: DecorativeShape_1.default.names[i % DecorativeShape_1.default.names.length] })),
            react_1.default.createElement(TextVerticalSpacer_1.default, { level: "4" },
                react_1.default.createElement(Markdown_1.default, { overrides: MARKDOWN_1_OVERRIDES }, item))))); })));
};
exports.default = HighlightList;
